import type { GetToken } from '@clerk/types'

import isNil from 'lodash/fp/isNil'
import noop from 'lodash/fp/noop'

import commonEndpoints from '../api/endpoints'

// Approximatively between 2 to 5 seconds
const MAX_CLERK_RETRIES = 5000

export default function useApiWindow(retry = false) {
  if (typeof window === 'undefined') {
    return commonEndpoints(noop as GetToken, null)
  }

  let getToken = window.Clerk?.session?.getToken
  let userId: string | null | undefined = window.Clerk?.user?.id

  if (retry) {
    let retryCount = 0
    while (
      (isNil(window.Clerk) ||
        isNil(window.Clerk?.user) ||
        isNil(window.Clerk?.session)) &&
      retryCount < MAX_CLERK_RETRIES
    ) {
      userId = window.Clerk?.user?.id ?? null
      getToken = window.Clerk?.session?.getToken

      retryCount += 1
    }
  }

  return commonEndpoints(getToken ?? (noop as GetToken), userId)
}
